import React, { PureComponent } from 'react';
import '../App.css';
import firebase, { auth, provider } from '../firebase.js';
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth"
import {Alert, ToggleButtonGroup, ToggleButton, Button, Well, Glyphicon, ProgressBar, Tabs, Tab, Panel, PanelGroup, Table} from 'react-bootstrap';
import { StickyContainer, Sticky} from 'react-sticky';
//const jsPDF = require('jspdf');
import jsPDF from 'jspdf';
import {Link, Route} from "react-router-dom";
import mainLogo from'../orthopowertools.png';

 


class LEFS_Send_Link_Spanish extends PureComponent {
    
  constructor() {
    super();
    this.state = {
      currentItem: '', //this is a relic of the tutorial
      username: '', //this is a relic of the tutorial
      user_id: '', //this is the name of the patinet submitting the survey
      clinician_to_share_with: '', //the email that users enter in order to share their score with a clinician
      scores: [], //this displays the scores saved for each clinician
      scores_id: [], //this displays ID number for the scores saved for each clinician        
      items: [], //this is a relic of the tutorial   
      user: null, //this is the email address or lack of email address for the clincian who is logged in 
      patient_filter: '', //this allows clinicians to sort for results from a single individual
        
      patient_email_to_send_score: '', //this is the variable where clinicians enter the email of a patient they want to send a score to
      patient_name_to_send_score: '', //this is the variable where clinicians enter the given name of a patient they want to send a score to, which makes the email more personable
      clinician_name_to_send_score: '', //this is the variable where clinicians enter their own given name when they send  score to a patient, which makes the email more personable         
        
    //Calculator variables    
    selectedValue1: 4,
    selectedValue1_text: 'Ninguna dificultad con el trabajo habitual..',

    selectedValue2: 4,
    selectedValue2_text: 'Ninguna dificultad con los pasatiempos habituales..',

    selectedValue3: 4,
    selectedValue3_text: 'Ninguna dificultad para entrar o salir del baño',

    selectedValue4: 4,
    selectedValue4_text: 'Ninguna dificultad para caminar entre habitaciones',

    selectedValue5: 4,
    selectedValue5_text: 'Ninguna dificultad para ponerse los zapatos o los calcetines',

    selectedValue6: 4,
    selectedValue6_text: 'Ninguna dificultad para ponerse en cuclillas',

    selectedValue7: 4,
    selectedValue7_text: 'Ninguna dificultad para levantar un objeto del suelo',

    selectedValue8: 4,
    selectedValue8_text: 'Ninguna dificultad para realizar actividades ligeras en casa',

    selectedValue9: 4,
    selectedValue9_text: 'Ninguna dificultad para realizar actividades pesadas en casa',

    selectedValue10: 4,
    selectedValue10_text: 'Ninguna dificultad para entrar o salir de un coche',

    selectedValue11: 4,
    selectedValue11_text: 'Ninguna dificultad para caminar dos cuadras',

    selectedValue12: 4,
    selectedValue12_text: 'Ninguna dificultad para caminar una milla',

    selectedValue13: 4,
    selectedValue13_text: 'Ninguna dificultad para subir o bajar 10 escaleras',

    selectedValue14: 4,
    selectedValue14_text: 'Ninguna dificultad estando parado por una hora',

    selectedValue15: 4,
    selectedValue15_text: 'Ninguna dificultad estando sentado por una hora',

    selectedValue16: 4,
    selectedValue16_text: 'Ninguna dificultad corriendo sobre terreno plano',

    selectedValue17: 4,
    selectedValue17_text: 'Ninguna dificultad corriendo sobre terreno irregular',

    selectedValue18: 4,
    selectedValue18_text: 'Ninguna dificultad haciendo vueltas agudas mientras corre rápidamente',

    selectedValue19: 4,
    selectedValue19_text: 'Ninguna dificultad saltando',

    selectedValue20: 4,
    selectedValue20_text: 'Ninguna dificultad volteandose en la cama ',         
        
        
    }
  this.handleChange = this.handleChange.bind(this);
  this.handleSubmit = this.handleSubmit.bind(this);
  this.handleSubmitSendInvite = this.handleSubmitSendInvite.bind(this);      
  this.modifyData = this.modifyData.bind(this);
  this.login = this.login.bind(this); 
  this.logout = this.logout.bind(this);
      
     
      
  }
    
componentDidMount() {
    
    
if (this.state.user != null){
    if(this.state.user.email === "orthotoolkit@gmail.com" | this.state.user.email === "neurologytoolkit@gmail.com"){    
          

  const LEFSScoresRef = firebase.firestore();
  LEFSScoresRef.settings({
      timestampsInSnapshots: true
  });        
        
  LEFSScoresRef.collection("lefs_scores").get().then(querySnapshot =>{
      
      
    const data_combined = [];  
      
    querySnapshot.docs.forEach(doc => {
         const myData = doc.data()
         myData.id = doc.id //this part is a weird flaw in the system where querySnapshot doesn't actually pull the doc ID, so you have to do it seperately and then combined the document data with each doc ID
         data_combined.push(myData)
    })
      
    this.setState({
      scores: data_combined,
    });   
      
  })
              
        
}  else {
    
  const LEFSScoresRef = firebase.firestore();
  LEFSScoresRef.settings({
      timestampsInSnapshots: true
  });        
        
  LEFSScoresRef.collection("lefs_scores").where("shared_with", "==", this.state.user.email).get().then(querySnapshot =>{
      
      
    const data_combined = [];  
      
    querySnapshot.docs.forEach(doc => {
         const myData = doc.data()
         myData.id = doc.id
         data_combined.push(myData)
    })
      
    this.setState({
      scores: data_combined,
    });   
      
  }) 
      
    
}
}
    

    
    
  auth.onAuthStateChanged((user) => {
    if (user) {
      this.setState({ user });
    }
      

if (this.state.user != null){
    if(this.state.user.email === "orthotoolkit@gmail.com" | this.state.user.email === "neurologytoolkit@gmail.com"){ 
        
  const LEFSScoresRef = firebase.firestore();
  LEFSScoresRef.settings({
      timestampsInSnapshots: true
  });        
        
  LEFSScoresRef.collection("lefs_scores").get().then(querySnapshot =>{
      

    const data_combined = [];  
      
    querySnapshot.docs.forEach(doc => {
         const myData = doc.data()
         myData.id = doc.id
         data_combined.push(myData)
    })
      
    this.setState({
      scores: data_combined,
    });   
      
  }) 
                       
        
} else {
    

    
  const LEFSScoresRef = firebase.firestore();
  LEFSScoresRef.settings({
      timestampsInSnapshots: true
  });        
        
  LEFSScoresRef.collection("lefs_scores").where("shared_with", "==", this.state.user.email).get().then(querySnapshot =>{
      
    const data_combined = [];  
      
    querySnapshot.docs.forEach(doc => {
         const myData = doc.data()
         myData.id = doc.id
         data_combined.push(myData)
    })
      
    this.setState({
      scores: data_combined,
    });   
      
  }) 
     
    
}
}      

    
      
  });    
    
}    
    
handleChange(e) {
  this.setState({
    [e.target.name]: e.target.value.replace('"','')
  });
} 
    
handleSubmit(e) {
  e.preventDefault();  
  const LEFSScoresRef = firebase.firestore();
  LEFSScoresRef.settings({
      timestampsInSnapshots: true
  });  
  const lefs_score = LEFSScoresRef.collection("lefs_scores").add({
    shared_with: this.state.clinician_to_share_with,
    user: this.state.user_id,
    timestamp: firebase.firestore.FieldValue.serverTimestamp(),
    score_name: 'Escala Funcional De La Extremidad Inferior',
    Question_01_LEFS: this.state.selectedValue1,
    Question_02_LEFS: this.state.selectedValue2,
    Question_03_LEFS: this.state.selectedValue3,
    Question_04_LEFS: this.state.selectedValue4,
    Question_05_LEFS: this.state.selectedValue5,
    Question_06_LEFS: this.state.selectedValue6,
    Question_07_LEFS: this.state.selectedValue7,            
    Question_08_LEFS: this.state.selectedValue8,
    Question_09_LEFS: this.state.selectedValue9,
    Question_10_LEFS: this.state.selectedValue10,
    Question_11_LEFS: this.state.selectedValue11,
    Question_12_LEFS: this.state.selectedValue12,
    Question_13_LEFS: this.state.selectedValue13,
    Question_14_LEFS: this.state.selectedValue14,
    Question_15_LEFS: this.state.selectedValue15,
    Question_16_LEFS: this.state.selectedValue16,
    Question_17_LEFS: this.state.selectedValue17,
    Question_18_LEFS: this.state.selectedValue18,
    Question_19_LEFS: this.state.selectedValue19,
    Question_20_LEFS: this.state.selectedValue20,
    Total_Score_LEFS: (this.state.selectedValue1+this.state.selectedValue2+this.state.selectedValue3+this.state.selectedValue4+this.state.selectedValue5+this.state.selectedValue6+this.state.selectedValue7+this.state.selectedValue8+this.state.selectedValue9+this.state.selectedValue10+this.state.selectedValue11+this.state.selectedValue12+this.state.selectedValue13+this.state.selectedValue14+this.state.selectedValue15+this.state.selectedValue16+this.state.selectedValue17+this.state.selectedValue18+this.state.selectedValue19+this.state.selectedValue20),        
  });
  this.setState({
    clinician_to_share_with: '',         
  });
    alert('Thank you for using OrthoPowerTools! Your submission was received and will be shared with the following provider: ' + this.state.clinician_to_share_with + '.');   
    
} 
    
modifyData(score_id) {  
  const LEFSScoresRef = firebase.firestore();
  LEFSScoresRef.collection("lefs_scores").doc(String(score_id)).update({
    shared_with: "None"    
  });  
    alert('Score deleted.');     
    
} 
    
    
    
    
    
    
    
handleSubmitSendInvite(e) {
  e.preventDefault();  
  const PatientInvites = firebase.firestore();
  PatientInvites.settings({
      timestampsInSnapshots: true
  });
  const patient_invites = PatientInvites.collection("lefs_spanish_patient_invites").add({
    patient_email_to_send_score: this.state.patient_email_to_send_score,
    clinician_who_sent_email: this.state.user.email,       
    patient_name_to_send_score: this.state.patient_name_to_send_score,
    clinician_who_sent_name: this.state.clinician_name_to_send_score,        
    timestamp: firebase.firestore.FieldValue.serverTimestamp(),      
  });
  this.setState({
    patient_email_to_send_score: '',
    clinician_who_sent: '',
    patient_name_to_send_score: '',
    clinician_name_to_send_score: '',  
  });
    if (this.state.patient_email_to_send_score !== ''){
    alert('Thank you for using OrthoPowerTools! A message has been sent to the entered email address with a link to complete a survey.');
    }
    else {
    alert('Thank you for using OrthoPowerTools! Your invitation was not sent because you did not enter the patients email address. To send the invitation, please enter the patients email address at the top of the page in the section that states "Enter the patients email address here"');        
    }       
    
}      
  
    
    
    
 
    
login() {
  auth.signInWithPopup(provider) 
    .then((result) => {
      const user = result.user;
      this.setState({
        user
      });
    });
    
}
    
logout() {
  auth.signOut()
    .then(() => {
      this.setState({
        user: null
      });
    });
}
    
  //Calculator Methods
    myCallback1  = (dataFromChild) => {
    this.setState({selectedValue1: dataFromChild});
    }
    myCallback1_text  = (dataFromChild) => {
    this.setState({selectedValue1_text: dataFromChild});
    }
    myCallback2  = (dataFromChild) => {
    this.setState({selectedValue2: dataFromChild});
    }
    myCallback2_text  = (dataFromChild) => {
    this.setState({selectedValue2_text: dataFromChild});
    }
    myCallback3  = (dataFromChild) => {
    this.setState({selectedValue3: dataFromChild});
    }
    myCallback3_text  = (dataFromChild) => {
    this.setState({selectedValue3_text: dataFromChild});
    }
    myCallback4  = (dataFromChild) => {
    this.setState({selectedValue4: dataFromChild});
    }
    myCallback4_text  = (dataFromChild) => {
    this.setState({selectedValue4_text: dataFromChild});
    }
    myCallback5  = (dataFromChild) => {
    this.setState({selectedValue5: dataFromChild});
    }
    myCallback5_text  = (dataFromChild) => {
    this.setState({selectedValue5_text: dataFromChild});
    }
    myCallback6  = (dataFromChild) => {
    this.setState({selectedValue6: dataFromChild});
    }
    myCallback6_text  = (dataFromChild) => {
    this.setState({selectedValue6_text: dataFromChild});
    }
    myCallback7  = (dataFromChild) => {
    this.setState({selectedValue7: dataFromChild});
    }
    myCallback7_text  = (dataFromChild) => {
    this.setState({selectedValue7_text: dataFromChild});
    }
    myCallback8  = (dataFromChild) => {
    this.setState({selectedValue8: dataFromChild});
    }
    myCallback8_text  = (dataFromChild) => {
    this.setState({selectedValue8_text: dataFromChild});
    }
    myCallback9  = (dataFromChild) => {
    this.setState({selectedValue9: dataFromChild});
    }
    myCallback9_text  = (dataFromChild) => {
    this.setState({selectedValue9_text: dataFromChild});
    }
    myCallback10  = (dataFromChild) => {
    this.setState({selectedValue10: dataFromChild});
    }
    myCallback10_text  = (dataFromChild) => {
    this.setState({selectedValue10_text: dataFromChild});
    }     
    myCallback11  = (dataFromChild) => {
    this.setState({selectedValue11: dataFromChild});
    }
    myCallback11_text  = (dataFromChild) => {
    this.setState({selectedValue11_text: dataFromChild});
    }
    myCallback12  = (dataFromChild) => {
    this.setState({selectedValue12: dataFromChild});
    }
    myCallback12_text  = (dataFromChild) => {
    this.setState({selectedValue12_text: dataFromChild});
    }
    myCallback13  = (dataFromChild) => {
    this.setState({selectedValue13: dataFromChild});
    }
    myCallback13_text  = (dataFromChild) => {
    this.setState({selectedValue13_text: dataFromChild});
    }
    myCallback14  = (dataFromChild) => {
    this.setState({selectedValue14: dataFromChild});
    }
    myCallback14_text  = (dataFromChild) => {
    this.setState({selectedValue14_text: dataFromChild});
    }
    myCallback15  = (dataFromChild) => {
    this.setState({selectedValue15: dataFromChild});
    }
    myCallback15_text  = (dataFromChild) => {
    this.setState({selectedValue15_text: dataFromChild});
    }
    myCallback16  = (dataFromChild) => {
    this.setState({selectedValue16: dataFromChild});
    }
    myCallback16_text  = (dataFromChild) => {
    this.setState({selectedValue16_text: dataFromChild});
    }
    myCallback17  = (dataFromChild) => {
    this.setState({selectedValue17: dataFromChild});
    }
    myCallback17_text  = (dataFromChild) => {
    this.setState({selectedValue17_text: dataFromChild});
    }
    myCallback18  = (dataFromChild) => {
    this.setState({selectedValue18: dataFromChild});
    }
    myCallback18_text  = (dataFromChild) => {
    this.setState({selectedValue18_text: dataFromChild});
    }
    myCallback19  = (dataFromChild) => {
    this.setState({selectedValue19: dataFromChild});
    }
    myCallback19_text  = (dataFromChild) => {
    this.setState({selectedValue19_text: dataFromChild});
    }
    myCallback20  = (dataFromChild) => {
    this.setState({selectedValue20: dataFromChild});
    }
    myCallback20_text  = (dataFromChild) => {
    this.setState({selectedValue20_text: dataFromChild});
    }
  
    
    

    
render() {
    
    if (this.state.user === null){
        return(
            
    <div className='app'>
      <header>
        <div className="wrapper">
        <Link to="/"><img src={mainLogo} style={{padding:15,width:200}} alt="orthotoolkit logo"/></Link>                 
        <Link to="/" style={{padding:15}}>Home</Link>            
        </div>
      </header>     

      <div style={{textAlign: "center", marginLeft:50, marginRight:50}}>
        <h1>Welcome to OrthoPowerTools, a project of <a href="https://orthotoolkit.com/">OrthoToolKit!</a></h1>

        <p>This initiative strives to improve the way in which people understand and communicate their orthopaedic health by providing all the features of OrthoToolKit as well as an <b>easy-to-use system</b> for clinicians to collect, store, and analyze common outcome measures from their patients.</p>
      
      <br/>
      
        
      <p>To learn more, please visit our <Link to="/">home page</Link></p>
      

 
      

      </div>
    </div>  
            
            
            
        );
    }
    
  return (
     
    <div className='app'>
      <header>
        <div className="wrapper">
        <Link to="/"><img src={mainLogo} style={{padding:15,width:200}} alt="orthotoolkit logo"/></Link>                 
        <Link to="/" style={{padding:15}}>Home</Link>            
        </div>
      </header>  
      

            <div style={{marginLeft:50, marginRight:50}}>
            <br/>
            <h2>Send Unique Spanish Language LEFS Link To Your Patients</h2>
            <br/>
            <form onSubmit={this.handleSubmitSendInvite}>
      
      
            <h4>Please fill in the below three text inputs. When you click the 'Send Score Invite' button, an email will be sent to your patient that contains a unique link to a Spanish language LEFS score. When the patient finishes the survey and clicks submit, an English translation will automatically be shared with you. An example email is listed below.</h4>
      
      
     
              <h4>Patient email address:</h4>                    
              <input type="text" name="patient_email_to_send_score" placeholder="Enter patient's email address here" onChange={this.handleChange} value={this.state.patient_email_to_send_score} /> 
      
              <h4>Patient given name:</h4>                          
              <input type="text" name="patient_name_to_send_score" placeholder="Enter patient's given name here (how name will be displayed on saved score)" onChange={this.handleChange} value={this.state.patient_name_to_send_score} /> 
      
              <h4>Your given name:</h4>                                
              <input type="text" name="clinician_name_to_send_score" placeholder="Enter the your name here (as you would like it to appear in the score invitation)" onChange={this.handleChange} value={this.state.clinician_name_to_send_score} />       
              <br />
      
          <button style = {{width: '100%'}}>Send Score Invite</button>       
      
      
    <table style={{width:"100%"}}>
        <tr>    
            <td><span>

    
      
            <p><h4>Email text:</h4></p>
            <p><h5>To: {this.state.patient_email_to_send_score}</h5></p>
            <p><h5>From: orthopowertools@gmail.com</h5></p>
            <p><h5>Subject: Escala Funcional De La Extremidad Inferior (LEFS) Solicitada Por El Proveedor</h5></p>
      
      
            <p><h5>Hola {this.state.patient_name_to_send_score},<br/><br/>Uno de sus proveedores de atención médica, {this.state.clinician_name_to_send_score}, le ha pedido que complete una encuesta de Escala Funcional De Extremidad Inferiores (LEFS). La información de esta encuesta es confidencial y solo se compartirá con su proveedor. <br/><br/>Haga clic <u> aquí </u> para completar la encuesta.</h5></p><br/>Atentamente,<br/>OrthoPowerTools         
      
            </span> </td>    
          
            <td><span>
      
            <p><h4>English Translation:</h4></p>
            <p><h5>To: {this.state.patient_email_to_send_score}</h5></p>
            <p><h5>From: orthopowertools@gmail.com</h5></p>
            <p><h5>Subject: Provider Requested Lower Extremity Functional Scale (LEFS) Completion</h5></p>
      
      
            <p><h5>Hello {this.state.patient_name_to_send_score},<br/><br/>One of your health care providers, {this.state.clinician_name_to_send_score}, has asked that you complete a Lower Extremity Functional Scale (LEFS) Survey. The information in this survey is confidential and will only be shared with your provider. <br/><br/>Please click <u>here</u> to complete the survey.</h5></p><br/>Best regards,<br/>OrthoPowerTools                      

            </span> </td>
        </tr>
    </table>
     
                    
            </form>        
      
      
              <div className='user-profile'>
                 <img src={this.state.user.photoURL} />
              </div>
      
      
            <br/>
      
            <div style={{textAlign: "center", marginLeft:50, marginRight:50}}>
            {this.state.user ? (
                <span>
                <button onClick={this.logout}>Logout</button>
                </span>
            ) : (
                <StyledFirebaseAuth
                    uiConfig={this.uiConfig}
                    firebaseAuth={firebase.auth()}
                />
  
            )}  
            </div>

            </div>      
      

      
    </div>
  );
}
}
    
export default LEFS_Send_Link_Spanish;

{/*
            <p><h5>Hello {this.state.patient_name_to_send_score},<br/><br/>One of your health care providers, {this.state.clinician_name_to_send_score}, has asked that you complete a Lower Extremity Functional Scale (LEFS) Survey. The information in this survey is confidential and will only be shared with your provider. <br/><br/>Please click <Link to={"/LEFS-Link/"+this.state.patient_name_to_send_score+"/"+this.state.user.email}> here</Link> to complete the survey.</h5></p><br/>Best regards,<br/>OrthoPowerTools`    
*/}


